// mission-secrets-test-env-template-writer.ts — 06k security L-03.
//
// Khung `~/.avatar/secrets/<mission>/test.env` do CLI tạo (không qua Write của
// Claude: umask 022 ⇒ 0644/0755, và Write file có sẵn cần Read — trái luật cấm
// Read secret). Thư mục 0700, file 0600 mở `O_EXCL`: file đã có ⇒ `created:false`,
// KHÔNG ghi đè, KHÔNG đọc giá trị. Mỗi key một dòng `KEY=` (người điền giá trị).
// N-5: `mkdir` không đổi quyền thư mục ĐÃ CÓ ⇒ thư mục có sẵn mà group/other có
// quyền, không phải thư mục thật (symlink) hoặc không thuộc uid hiện tại ⇒ ném lỗi.
import { constants, promises as fs } from "node:fs";
import { missionSecretsDir, missionTestEnvPath } from "./mission-secrets-test-env-loader.js";

export const TEST_ENV_TEMPLATE_KEY_RE = /^[A-Z][A-Z0-9_]{0,63}$/;

export interface TestEnvTemplateResult {
  created: boolean;
  path: string;
  keys: string[];
}

/** Tách `K1,K2`, bỏ trùng; key sai mẫu ⇒ ném `Error` nêu đúng key đó. */
export function parseTestEnvTemplateKeys(raw: string): string[] {
  const keys = [...new Set(raw.split(",").map((k) => k.trim()))];
  const bad = keys.filter((k) => !TEST_ENV_TEMPLATE_KEY_RE.test(k));
  if (keys.length === 0 || bad.length > 0) {
    throw new Error(
      `--keys sai mẫu ${TEST_ENV_TEMPLATE_KEY_RE.source}: ${JSON.stringify(bad.length > 0 ? bad : [raw])}`,
    );
  }
  return keys;
}

async function assertPrivateSecretsDir(dir: string): Promise<void> {
  const st = await fs.lstat(dir);
  const uid = process.getuid?.();
  const foreign = uid !== undefined && st.uid !== uid;
  if (st.isDirectory() && (st.mode & 0o077) === 0 && !foreign) return;
  const mode = (st.mode & 0o777).toString(8).padStart(3, "0");
  throw new Error(
    `Thư mục secret ${dir} không an toàn (quyền ${mode}, uid ${st.uid}${st.isDirectory() ? "" : ", không phải thư mục thật"}) — ` +
      `chưa tạo test.env. Sửa: \`chmod 700 ${dir}\` (thư mục phải của bạn — owner khác thì xoá/tạo lại).`,
  );
}

export async function writeTestEnvTemplate(
  missionId: string,
  keys: readonly string[],
): Promise<TestEnvTemplateResult> {
  const path = missionTestEnvPath(missionId);
  const dir = missionSecretsDir(missionId);
  await fs.mkdir(dir, { recursive: true, mode: 0o700 });
  await assertPrivateSecretsDir(dir);
  let handle: fs.FileHandle;
  try {
    const flags = constants.O_WRONLY | constants.O_CREAT | constants.O_EXCL;
    handle = await fs.open(path, flags, 0o600);
  } catch (err) {
    if ((err as NodeJS.ErrnoException).code === "EEXIST") {
      return { created: false, path, keys: [...keys] };
    }
    throw err;
  }
  try {
    await handle.writeFile(keys.map((k) => `${k}=\n`).join(""), "utf8");
    await handle.sync();
  } finally {
    await handle.close();
  }
  return { created: true, path, keys: [...keys] };
}
